import { useEffect, useRef } from 'react'

import { useSelector } from 'react-redux'

import { basketOrderLoaded, portionSizeSelectedTracking } from 'actions/basket'
import { useNumPortions } from 'hooks/basket/useNumPortions'
import { useBasket } from 'routes/Menu/domains/basket'
import { fetchData } from 'routes/Menu/fetchData'
import { getBasketOrderId } from 'selectors/basket'

type Args = {
  query: Record<string, any>
  params: Record<string, any>
}

export const useMenuBootstrap = ({ query, params }: Args) => {
  const prevOrderIdRef = useRef<string | undefined>()
  const prevQueryRef = useRef<string>()
  const prevParamsRef = useRef<string>()

  const storeOrderId = useSelector(getBasketOrderId)
  const { orderId, addRecipeByUuid } = useBasket()
  const { numPortions } = useNumPortions()

  useEffect(() => {
    const prevOrderId = prevOrderIdRef.current
    const isMount = prevOrderId === undefined
    const orderChanged = prevOrderId && orderId && prevOrderId !== orderId
    const forceReload = (storeOrderId && storeOrderId !== orderId) || query.reload

    const queryStr = JSON.stringify(query)
    const paramsStr = JSON.stringify(params)
    const queryChanged = prevQueryRef.current !== queryStr
    const paramsChanged = prevParamsRef.current !== paramsStr

    const shouldFetch = isMount ? forceReload : orderChanged || queryChanged || paramsChanged

    const run = async () => {
      if (isMount) {
        if (orderId && orderId === storeOrderId) {
          basketOrderLoaded(orderId)
        }
        if (orderId) {
          portionSizeSelectedTracking(numPortions, orderId)
        }
      }

      if (shouldFetch) {
        await fetchData({ query, params }, true, undefined, { addRecipe: addRecipeByUuid })
      }
    }

    run()

    prevOrderIdRef.current = orderId
    prevQueryRef.current = queryStr
    prevParamsRef.current = paramsStr
  }, [orderId, storeOrderId, query, params, addRecipeByUuid, numPortions])
}
